import { useState } from "react";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import TableReporteVendedoresExternos from "../componente/TableReporteVendedoresExternos";
import AdminPanel from "../componente/AdminPanel";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`comisiones-tabpanel-${index}`}
      aria-labelledby={`comisiones-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `comisiones-tab-${index}`,
    "aria-controls": `comisiones-tabpanel-${index}`,
  };
}

export default function ReporteVendedoresExternosPage() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <SingleTableBoxScene title="Reporte de Vendedores Externos / Call Center">
      <Box sx={{ width: "100%" }}>
        {/* Tabs de navegación */}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="Tabs de comisiones"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                minHeight: 48,
              },
              "& .Mui-selected": {
                color: "primary.main",
              },
            }}
          >
            <Tab
              icon={<AssessmentIcon />}
              iconPosition="start"
              label="Reporte de Comisiones"
              {...a11yProps(0)}
            />
            <Tab
              icon={<AdminPanelSettingsIcon />}
              iconPosition="start"
              label="Administración"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>

        {/* Panel: Reporte */}
        <TabPanel value={tabValue} index={0}>
          <TableReporteVendedoresExternos />
        </TabPanel>

        {/* Panel: Administración */}
        <TabPanel value={tabValue} index={1}>
          <AdminPanel />
        </TabPanel>
      </Box>
    </SingleTableBoxScene>
  );
}